export const Primary = '#0f57fb';
export const Secondary = '#0e53f0';
export const Tertiary = '#f3f7ff';
export const Quaternary = '#0f57fb';
